import { render } from "./EmptyState.vue?vue&type=template&id=65774c94"
import script from "./EmptyState.vue?vue&type=script&lang=js"
export * from "./EmptyState.vue?vue&type=script&lang=js"
script.render = render

export default script